/* Cosmetic shopping-session clock only. No pricing or commerce side effects. */
(function () {
  'use strict';
  if (window.__enovaSessionTimerV1) return;
  window.__enovaSessionTimerV1 = true;

  var DURATION = 20 * 60 * 1000;
  var PREFIX = 'enova:session-timer:v1:';
  var initialized = false;

  function valid(record, now) {
    return record && record.version === 1 &&
      Number.isSafeInteger(record.startedAt) && Number.isSafeInteger(record.deadline) &&
      record.startedAt >= 0 && record.startedAt <= now &&
      record.deadline - record.startedAt === DURATION;
  }

  function readSession(scope, mayStart, now) {
    if (!scope) return null;
    // Fail closed: no in-memory countdown that falsely suggests persistence.
    // Invalid records are left untouched, not treated as a fresh arrival.
    try {
      var storage = window.localStorage;
      var key = PREFIX + scope;
      var raw = storage.getItem(key);
      if (raw === null && mayStart) {
        var created = {version: 1, startedAt: now, deadline: now + DURATION};
        storage.setItem(key, JSON.stringify(created));
        raw = storage.getItem(key);
      }
      if (raw === null) return null;
      var record = JSON.parse(raw);
      return valid(record, now) ? record : null;
    } catch (_) {
      return null;
    }
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node && node.textContent !== value) node.textContent = value;
  }

  function render(mayStart) {
    var now = Date.now();
    var sessions = new Map();
    document.querySelectorAll('[data-session-timer]').forEach(function (root) {
      var scope = root.getAttribute('data-timer-scope');
      if (!sessions.has(scope)) sessions.set(scope, readSession(scope, mayStart, now));
      var record = sessions.get(scope);
      if (!record) {
        root.hidden = true;
        return;
      }
      var seconds = Math.max(0, Math.min(DURATION / 1000, Math.ceil((record.deadline - now) / 1000)));
      var clock = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
      setText(root, '[data-session-clock]', clock);
      setText(root, '[data-session-state]', 'Session');
      root.hidden = false;
    });
  }

  function refresh() { render(false); }
  function init() {
    // A normal store visit starts the session; no acceptance URL is required.
    // Reloads, navigation and section reloads reuse the same absolute deadline.
    render(true);
    if (!initialized) {
      initialized = true;
      setInterval(refresh, 1000);
    }
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', function (event) {
    if (event.key === null || (typeof event.key === 'string' && event.key.indexOf(PREFIX) === 0)) refresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
}());
